// The full authorities object (with every permission key) exceeds the ~4KB
// per-cookie limit once URL-encoded, so the browser silently rejects it.
// omuni-web's middleware only validates a fixed subset of permissions to gate
// routes; everything else is hydrated client-side from /v2/users/me.
// Keep this list in sync with omuni-web/src/middleware.ts.
const pickGroup = (group, keys) => {
  if (!group) return undefined;
  const result = {};
  keys.forEach((key) => {
    if (group[key] !== undefined) result[key] = group[key];
  });
  return result;
};

export const extractMinimalAuthorities = (permissions) => {
  if (!permissions) return permissions;

  return {
    contacts: pickGroup(permissions.contacts, ["listContacts"]),
    cases: pickGroup(permissions.cases, ["listCases"]),
    users: pickGroup(permissions.users, ["listUser"]),
    tokens: pickGroup(permissions.tokens, ["readTokens"]),
    customAttributes: pickGroup(permissions.customAttributes, ["updateCustomAttributes"]),
    publications: pickGroup(permissions.publications, ["listPublications"]),
    departments: pickGroup(permissions.departments, ["getDepartments"]),
    channels: pickGroup(permissions.channels, ["listChannels"]),
    contactCenter: pickGroup(permissions.contactCenter, [
      "viewAgents",
      "viewSkills",
      "viewBreaks",
      "viewDashboard",
      "viewQueues",
      "viewRoutingRules",
    ]),
    audit: pickGroup(permissions.audit, ["getAudit"]),
    forms: pickGroup(permissions.forms, ["getForms"]),
    monitoring: pickGroup(permissions.monitoring, ["viewMonitoring"]),
    calendar: pickGroup(permissions.calendar, ["viewCalendar"]),
    campaigns: pickGroup(permissions.campaigns, ["getCampaigns", "getCampaignsMetrics"]),
    sensitive: pickGroup(permissions.sensitive, ["listPattern"]),
  };
};
